(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    /* Compact header once the page has scrolled */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Department panels: click toggles (touch and keyboard); hover is CSS */
    var cats = header.querySelector('[data-cats]');
    function closePanels(except) {
      header.querySelectorAll('.hdr__catitem.is-open').forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var a = li.querySelector('[data-cat-toggle]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
    if (cats) {
      cats.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cat-toggle]');
        if (!toggle) return;
        var li = toggle.closest('.hdr__catitem');
        if (!li.classList.contains('is-open')) {
          e.preventDefault();
          closePanels(li);
          li.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
      document.addEventListener('click', function (e) {
        if (!cats.contains(e.target)) closePanels();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanels();
      });
    }

    /* Drawer menu */
    var drawer = document.querySelector('[data-menu-drawer]');
    var burger = header.querySelector('[data-menu-toggle]');
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('has-drawer');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var panel = drawer.querySelector('[data-menu-panel]');
      if (panel) panel.focus({ preventScroll: true });
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('has-drawer');
      if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus({ preventScroll: true }); }
    }
    if (burger) burger.addEventListener('click', function () {
      drawer && drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Phone search row */
    var stoggle = header.querySelector('[data-search-toggle]');
    var srow = document.getElementById('hdr-mobile-search');
    if (stoggle && srow) {
      stoggle.addEventListener('click', function () {
        var open = !srow.hidden;
        srow.hidden = open;
        stoggle.setAttribute('aria-expanded', String(!open));
        if (!open) {
          var f = srow.querySelector('[data-search-field]');
          if (f) requestAnimationFrame(function () { f.focus(); });
        }
      });
    }

    /* Autosuggest: products only, rendered server-side by sections/predictive-search */
    var SUGGEST = '/search/suggest?section_id=predictive-search&resources[type]=product&resources[limit]=6&q=';
    document.querySelectorAll('[data-search]').forEach(function (form) {
      var field = form.querySelector('[data-search-field]');
      var results = form.querySelector('[data-search-results]');
      if (!field || !results) return;
      var ctrl, timer;

      function clear() { results.innerHTML = ''; results.hidden = true; }
      function items() { return Array.from(results.querySelectorAll('[data-psearch-item]')); }
      function move(dir) {
        var list = items();
        if (!list.length) return;
        var i = list.findIndex(function (el) { return el.classList.contains('is-active'); });
        list.forEach(function (el) { el.classList.remove('is-active'); });
        i = i === -1 ? (dir > 0 ? 0 : list.length - 1) : (i + dir + list.length) % list.length;
        list[i].classList.add('is-active');
        list[i].scrollIntoView({ block: 'nearest' });
      }
      function suggest(q) {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        fetch(SUGGEST + encodeURIComponent(q), { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var inner = tmp.querySelector('[data-psearch]');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = !results.innerHTML.trim();
          })
          .catch(function (err) { if (err.name !== 'AbortError') clear(); });
      }

      field.addEventListener('input', function () {
        var q = field.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { clear(); return; }
        timer = setTimeout(function () { suggest(q); }, 180);
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
        else if (e.key === 'Escape') { clear(); }
        else if (e.key === 'Enter') {
          var active = results.querySelector('[data-psearch-item].is-active');
          if (active) { e.preventDefault(); window.location.href = active.href; }
        }
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) clear();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Filters and sorting refresh the results in place (Section Rendering API);
     the form still works as a plain GET without JavaScript. */
  (function () {
    var root = document.querySelector('[data-results-root]');
    if (!root) return;
    var sectionId = root.closest('.shopify-section') && root.closest('.shopify-section').id.replace('shopify-section-', '');
    var timer, ctrl;

    function form() { return root.querySelector('[data-filter-form]'); }

    function buildUrl(extra) {
      var f = form();
      var params = new URLSearchParams(f ? new FormData(f) : undefined);
      // Drop empty price fields so the URL stays clean
      Array.from(params.keys()).forEach(function (k) {
        if (k.indexOf('filter.v.price') === 0 && params.get(k) === '') params.delete(k);
      });
      if (extra) Object.keys(extra).forEach(function (k) { params.set(k, extra[k]); });
      var base = f ? f.getAttribute('action') : window.location.pathname;
      var qs = params.toString();
      return base + (qs ? '?' + qs : '');
    }

    function load(url, push) {
      if (!sectionId) { window.location.href = url; return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      root.classList.add('is-loading');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { signal: ctrl.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-results-root]');
          if (!fresh) { window.location.href = url; return; }
          ['[data-results]', '[data-filters]', '[data-results-count]'].forEach(function (sel) {
            var a = root.querySelector(sel), b = fresh.querySelector(sel);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          if (push) window.history.pushState({ url: url }, '', url);
          root.classList.remove('is-loading');
          var top = root.getBoundingClientRect().top + window.scrollY - 120;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        })
        .catch(function (err) { if (err.name !== 'AbortError') window.location.href = url; });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-filter-form]')) {
        clearTimeout(timer);
        timer = setTimeout(function () { load(buildUrl(), true); }, e.target.type === 'number' ? 600 : 120);
      } else if (e.target.matches('[data-sort-select]')) {
        var mirror = root.querySelector('[data-sort-mirror]');
        if (mirror) mirror.value = e.target.value;
        load(buildUrl({ sort_by: e.target.value }), true);
      }
    });

    root.addEventListener('submit', function (e) {
      if (!e.target.closest('[data-filter-form]')) return;
      e.preventDefault();
      load(buildUrl(), true);
      closeFilters();
    });

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link], .pager a');
      if (!link) return;
      e.preventDefault();
      load(link.getAttribute('href'), true);
    });

    window.addEventListener('popstate', function (e) {
      load(window.location.pathname + window.location.search, false);
    });

    /* Filters drawer below 992px */
    var panel = root.querySelector('[data-filters-panel]');
    var overlay = root.querySelector('.coll__overlay');
    var opener = root.querySelector('[data-filters-open]');
    function openFilters() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('has-drawer');
    }
    function closeFilters() {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('has-drawer');
    }
    if (opener) opener.addEventListener('click', openFilters);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-filters-close]')) closeFilters(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var form = root.querySelector('[data-pdp-form]');
    var dataEl = document.querySelector('[data-pdp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    /* Quantity steppers (buy box and bar share the value) */
    function syncQty(val) {
      val = Math.max(1, parseInt(val, 10) || 1);
      document.querySelectorAll('[data-qty-in]').forEach(function (i) { if (i.value !== String(val)) i.value = val; });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn || !btn.closest('[data-pdp], [data-satc]')) return;
      var input = btn.parentElement.querySelector('[data-qty-in]');
      var n = parseInt(input.value, 10) || 1;
      syncQty(btn.dataset.qty === '+' ? n + 1 : n - 1);
    });
    document.addEventListener('input', function (e) { if (e.target.matches('[data-qty-in]')) syncQty(e.target.value); });

    /* Gallery */
    var hero = root.querySelector('[data-pdp-hero] img');
    function showMedia(id, full) {
      if (!hero) return;
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      var target = null;
      thumbs.forEach(function (t) {
        var match = id ? t.dataset.mediaId === String(id) : t.dataset.full === full;
        t.classList.toggle('is-active', match);
        if (match) target = t;
      });
      // A variant picture that has no thumbnail of its own (same colour as another) still shows large
      var src = (target && target.dataset.full) || full;
      if (src) { hero.src = src; hero.removeAttribute('srcset'); }
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pdp-thumb]');
      if (t) showMedia(null, t.dataset.full);
    });

    /* Options → variant */
    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-pdp-option]').forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        out[i] = checked ? checked.value : null;
      });
      return out;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function reveal(attr, id) {
      document.querySelectorAll('[' + attr + ']').forEach(function (el) {
        el.hidden = el.getAttribute(attr) !== String(id);
      });
    }
    function markAvailability(opts) {
      root.querySelectorAll('[data-pdp-option]').forEach(function (fs, i) {
        fs.querySelectorAll('.pill').forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[i] = val;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return j === i ? o === val : (test[j] == null || o === test[j]); });
          });
          pill.classList.toggle('is-oos', !ok);
        });
        var lbl = fs.querySelector('[data-pdp-optvalue]');
        if (lbl && opts[i]) lbl.textContent = opts[i];
      });
    }
    function setAddState(available) {
      var add = root.querySelector('[data-pdp-add]');
      var bar = document.querySelector('[data-satc-add]');
      [add, bar].forEach(function (b) { if (b) b.disabled = !available; });
      document.querySelectorAll('[data-pdp-addtext]').forEach(function (t) { t.textContent = available ? 'Add to basket' : 'Out of stock'; });
    }
    function applyVariant(v) {
      var idInput = form && form.querySelector('[data-pdp-variant-id]');
      if (!v) { setAddState(false); document.querySelectorAll('[data-pdp-addtext]').forEach(function (t) { t.textContent = 'Unavailable'; }); return; }
      if (idInput) idInput.value = v.id;
      reveal('data-variant-price', v.id);
      reveal('data-variant-stock', v.id);
      var sku = root.querySelector('[data-pdp-sku]');
      if (sku) { sku.textContent = 'SKU ' + (v.sku || ''); sku.hidden = !v.sku; }
      // Picture: this variant's own, else another variant of the same colour that has one
      var pic = v.featured_media;
      if (!pic) {
        var colourFs = root.querySelector('[data-pdp-option] legend');
        var ci = Array.from(root.querySelectorAll('[data-pdp-option]')).findIndex(function (fs) { return /colou?r/i.test(fs.querySelector('legend').textContent); });
        if (ci >= 0) {
          var sib = variants.find(function (o) { return o.featured_media && o.options[ci] === v.options[ci]; });
          if (sib) pic = sib.featured_media;
        }
      }
      if (pic && pic.id) showMedia(pic.id, pic.preview_image && pic.preview_image.src);
      setAddState(v.available);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-pdp-option]')) return;
      var opts = selectedOptions();
      markAvailability(opts);
      applyVariant(findVariant(opts));
    });
    if (root.querySelector('[data-pdp-option]')) markAvailability(selectedOptions());

    /* Bottom bar */
    var satc = document.querySelector('[data-satc]');
    var addBtn = root.querySelector('[data-pdp-add]');
    if (satc && addBtn && 'IntersectionObserver' in window) {
      satc.hidden = false;
      document.body.classList.add('has-satc');
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        satc.classList.toggle('is-in', past);
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(addBtn);
      var satcAdd = satc.querySelector('[data-satc-add]');
      if (satcAdd && form) satcAdd.addEventListener('click', function () { form.requestSubmit(addBtn); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-recs]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.closest('.shopify-section').style.display = 'none';
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
